import HomePage from "./pages/HomePage";
import FormPage from "./pages/FormPage";
import NotFoundPage from "./pages/NotFoundPage";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/forms/:formId",
    element: <FormPage />,
  },
  {
    path: "*", // Catch-all for undefined routes
    element: <NotFoundPage />,
  },
];

export default routes;
